import { graphql } from '~/graphql';
import { useGraphqlQuery } from '~/hooks/useGraphqlQuery';

const getAllUnitsQuery = graphql(`
  query GetAllUnits {
    units {
      code
      category
      name
    }
  }
`);

export function useGetAllUnits() {
  return useGraphqlQuery(getAllUnitsQuery, ['units']);
}
